import { render, staticRenderFns } from "./invoice-rise.vue?vue&type=template&id=fbdf0638&scoped=true&"
import script from "./invoice-rise.vue?vue&type=script&lang=js&"
export * from "./invoice-rise.vue?vue&type=script&lang=js&"
import style0 from "./invoice-rise.vue?vue&type=style&index=0&id=fbdf0638&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdf0638",
  null
  
)

export default component.exports